import { render, staticRenderFns } from "./CurrentTest.vue?vue&type=template&id=cbe1f76c"
import script from "./CurrentTest.vue?vue&type=script&lang=ts"
export * from "./CurrentTest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports